export function parseHash(hash: string): { code: string; username: string } {
  const match = (hash || '').match(/^#?(.*);(.*)/);
  const [username = '', code = ''] = match ? match.slice(1) : [];
  return { code, username };
}
